/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Instagram_Review_Patricia_AltInputs */

const es_landing_instagram_review_patricia_alt = /** @type {(inputs: Landing_Instagram_Review_Patricia_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación de Instagram de patri_psicologa recomendando Zarpar para un cumpleaños en barco`)
};

const gl_landing_instagram_review_patricia_alt = /** @type {(inputs: Landing_Instagram_Review_Patricia_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación de Instagram de patri_psicologa recomendando Zarpar para un aniversario en barco`)
};

const en_landing_instagram_review_patricia_alt = /** @type {(inputs: Landing_Instagram_Review_Patricia_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram post by patri_psicologa recommending Zarpar for a birthday boat trip`)
};

/**
* | output |
* | --- |
* | "Instagram post by patri_psicologa recommending Zarpar for a birthday boat trip" |
*
* @param {Landing_Instagram_Review_Patricia_AltInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_instagram_review_patricia_alt = /** @type {((inputs?: Landing_Instagram_Review_Patricia_AltInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Instagram_Review_Patricia_AltInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_instagram_review_patricia_alt(inputs)
	if (locale === "en") return en_landing_instagram_review_patricia_alt(inputs)
	return es_landing_instagram_review_patricia_alt(inputs)
});